<template>
  <div
    class="info-con infinite-list"
    v-infinite-scroll="loadDataByPage"
    style="overflow-y: auto"
    :infinite-scroll-delay="500"
    :infinite-scroll-distance="90"
  >
    <div class="tmp-title nav-title">
      <div class="tt-left">
        <h2>我的收藏</h2>
      </div>
    </div>
    <!-- 设计列表 -->
    <section class="design-list">
      <div class="mydeisgn-datalist">
        <ul class="clearFix designdatas">
          <li
            v-for="(item, index) in collectList"
            :key="index"
            @mouseover="mouseoveritem(item)"
            @mouseout="mouseoutitem(item)"
            @click="useTeamTemplate(item)"
          >
            <div class="mydesign-datalist-item-top" :data-type="item.type">
              <img :src="item.cover_url" alt="" />
              <div
                class="item-collect"
                v-show="item.showopt"
                @click.stop="colletOperate(item, index)"
              >
                <span
                  :class="{
                    'icon-collected': true,
                    'icon-collection': item.is_collect,
                    'icon-uncollection': !item.is_collect,
                    iconfont: true,
                  }"
                ></span>
              </div>
            </div>
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </section>
    <!-- 加载状态显示 -->
    <div class="loading-icon" v-show="!noCotent">
      <span class="el-icon-loading" v-show="loading"></span>
      <span class="images-request-tip" v-if="load_status_text">{{
        load_status_text
      }}</span>
    </div>
    <!-- 内容为空 -->
    <teamNull :imgtext="'空空如也~快去收藏喜欢的模板吧'" v-if="noCotent" />
    <!--团队过期弹出框-->
    <expireTeamDialog />
    <!-- 回到顶部 -->
    <el-backtop
      target=".info-con"
      :bottom="30"
      :right="30"
      :visibility-height="30"
    >
      <img src="@/assets/image/backtop.png" alt="" />
    </el-backtop>
  </div>
</template>

<script>
import { Collect } from "@/config/axios/new_api";
import Index from "@/config/mixin/index.js";
import teamNull from "@/components/common/teamNull.vue";
import Vue from "vue";
export default {
  components: {
    teamNull,
  },
  mixins: [Index],
  data() {
    return {
      noContent: false,
      Pagination: {
        page: 1,
        page_size: 25,
      },
      collectList: [],
      noCotent: false,
      loaded: false,
      loading: false,
    };
  },

  computed: {
    teamList() {
      return this.$store.getters.teamList; // 后期直接使用domani
    },
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
    checkWebp: function () {
      try {
        return (
          document
            .createElement("canvas")
            .toDataURL("image/webp")
            .indexOf("data:image/webp") == 0
        );
      } catch (err) {
        return false;
      }
    },
    load_status_text() {
      if (this.loaded) {
        if (this.collectList.length > 25) {
          return "没有更多数据了";
        } else {
          return "";
        }
      }
      return "数据加载中";
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData(
      data = {
        team_id: this.loginInfo.current_team_id,
        page_size: this.Pagination.page_size,
        page: this.Pagination.page,
        design_type: 1
      }
    ) {
      let _this = this;
      Collect.getData(data, "post")
        .then((res) => {
          if (res.status == 1) {
            var collectList = res.data.data;

            //数据为空
            if ((!collectList || collectList.length == 0) && res.data.pagination.current_page == 1) {
              this.noCotent = true;
              this.loaded = true;
              return;
            }
            /* 数据已全部加载 */
            if (this.Pagination.page >= Math.ceil(res.data.pagination.total / this.Pagination.page_size)) {
              this.loaded = true;
              this.loading = false;
            }

            collectList.forEach((item) => {
              item.is_collect = 1;
              item.size = item.size;
              item.showopt = false;
            });
            _this.collectList = collectList;
          } else {
            this.loaded = true;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loaded = true;
          this.loading = false;
        });
    },

    colletOperate(item, index) {
      let res = this.expireHandle();
      if(res){
        Vue.prototype
            .$confirm("确定要取消收藏吗?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "messageBoxClass",
            cancelButtonClass: "cancelbutton",
            confirmButtonClass: "confirmbutton",
            type: "warning",
            })
            .then(() => {
            Collect.uncollect({
                team_id: this.loginInfo.current_team_id,
                team_template_id: item.team_template_id,
            }).then((res) => {
                if (res.status == 1) {
                item.is_collect = 0;
                item.showopt = false;
                this.$set(this.collectList, index, item);
                this.collectList.splice(index, 1);
                if (this.collectList.length == 0) {
                    //展示没有数据了
                    this.noCotent = true;
                }
                } else {
                Vue.prototype.$message.error(res.error || res.message);
                }
            });
            })
            .catch(() => {
            return false;
            });
        }
    },
    useTeamTemplate(item) {
      let res = this.expireHandle();
      if (res) {
        this.goDesignworkbench(item, item.team_template_id);
      }
    },
    mouseoveritem(item) {
      item.showopt = true;
    },
    mouseoutitem(item) {
      item.showopt = false;
    },
    loadDataByPage() {
      if (this.loaded) {
        this.loading = false;
        return;
      }

      this.loading = true;
      let current_page = this.Pagination.page;

      this.$set(this.Pagination, "page", current_page++);
      this.getData();
    },
  },
};
</script>

<style lang="scss">
.messageBoxClass {
  .el-message-box__header {
    padding: 16px 16px 14px;
  }
  .el-message-box__content {
    padding: 10px 15px 24px 15px;
  }
  .el-message-box__status + .el-message-box__message {
    padding-left: 26px;
  }
  .el-message-box__status {
    font-size: 18px !important;
  }
  .el-message-box__btns {
  }
  //  .el-button--primary {
  //   &.confirmbutton {
  //     background-color: #7966ff !important;
  //     border-color: #7966ff !important;
  //     &:hover {
  //       background: #9485ff !important;
  //       border-color: #9485ff !important;
  //     }
  //   }
  // }
  // .el-button {
  //   &.cancelbutton {
  //     &:hover {
  //       background: #fbfaff !important;
  //       color: #7966ff !important;
  //       border-color: #e8e5ff !important;
  //     }
  //   }
  // }
}
</style>

<style lang="scss">
// ::v-deep( .el-button--primary {
//   &.confirmbutton {
//     background-color: #7966ff !important;
//     border-color: #7966ff !important;
//     &:hover {
//       background: #9485ff !important;
//       border-color: #9485ff !important;
//     }
//   }
// }
// ::v-deep( .el-button {
//   &.cancelbutton {
//     &:hover {
//       background: #fbfaff !important;
//       color: #7966ff !important;
//       border-color: #e8e5ff !important;
//     }
//   }
// }

.info-con {
  min-height: 100vh;
  height: 100vh;
  padding: 40px 56px 40px 24px;
}
.clearFix::after {
  content: "";
  clear: both;
  display: block;
}
.page-title {
  margin-top: 26px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 20px;
}
#msg-del-content,
#overdue-toast-creator,
#overdue-toast-member {
  padding: 100px 56px;
  line-height: 22px;
  text-align: center;
}
.buts {
  margin-top: 26px;
  button {
    width: 100px;
    height: 32px;
    border-radius: 2px;
    color: #fff;
    background: #c6c6c6;
    font-family: PingFangSC-Light;
  }
}

.design-list {
  margin-top: 24px;
}
.mydeisgn-datalist {
  ul {
    width: 100%;
    position: relative;

    li {
      box-sizing: border-box;
      -ms-box-sizing: border-box;
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      width: 150px;
      height: 180px;
      p {
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #333;
        line-height: 20px;
        margin-top: 10px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-font-smoothing: antialiased;
      }
    }
  }
}

.mydesign-datalist-item-top {
  height: 150px;
  width: 100%;
  overflow: hidden;
  background: #f7f7f7;
  border-radius: 8px;
  padding: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  -ms-box-sizing: border-box;
  position: relative;

  img {
    max-width: 100%;
    position: absolute;
  }

  &[data-type="5"],
  &[data-type="9"],
  &[data-type="8"],
  &[data-type="18"],
  &[data-type="81"],
  &[data-format="1"],
  &[data-type="82"],
  &[data-type="6"],
  &[data-type="97"],
  &[data-type="98"],
  &[data-type="99"],
  &[data-type="101"],
  &[data-type="102"],
  &[data-type="106"],
  &[data-type="107"],
  &[data-type="108"],
  &[data-type="109"],
  &[data-type="110"],
  &[data-type="111"],
  &[data-type="112"],
  &[data-type="114"],
  &[data-type="15"],
  &[data-type="16"],
  &[data-type="19"] {
    img {
      width: 100%;
      overflow: hidden;
    }
  }

  &[data-type="10"],
  &[data-type="11"],
  &[data-type="12"],
  &[data-type="13"],
  &[data-type="14"],
  &[data-type="17"],
  &[data-type="96"],
  &[data-type="100"],
  &[data-type="103"],
  &[data-type="104"],
  &[data-type="105"],
  &[data-format="2"],
  &[data-type="80"] {
    img {
      height: 100%;
      overflow: hidden;
    }
  }

  &[data-type="0"] {
    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: none;
  }
}
.mydesign-datalist-item-top {
  &:hover {
    &::after {
      display: block;
    }

    // background: -moz-linear-gradient(
    //   90deg,
    //   rgba(0, 0, 0, 0.1) 0%,
    //   rgba(255, 255, 255, 0.3) 30%,
    //   rgba(255, 255, 255, 0.3) 70%,
    //   rgba(0, 0, 0, 0.1) 100%
    // );
    // background: -ms-linear-gradient(
    //   90deg,
    //   rgba(0, 0, 0, 0.1) 0%,
    //   rgba(255, 255, 255, 0.3) 30%,
    //   rgba(255, 255, 255, 0.3) 70%,
    //   rgba(0, 0, 0, 0.1) 100%
    // );
    // background: -webkit-linear-gradient(
    //   90deg,
    //   rgba(0, 0, 0, 0.1) 0%,
    //   rgba(255, 255, 255, 0.3) 30%,
    //   rgba(255, 255, 255, 0.3) 70%,
    //   rgba(0, 0, 0, 0.1) 100%
    // );
  }
}

.item-collect {
  position: absolute;
  top: 8px;
  cursor: pointer;
  text-align: center;
  width: 28px;
  height: 28px;
  background: #ffffff;
  border-radius: 4px;
  right: 8px;
  background-color: #fff;
  // border: 1px solid #dedede;
  z-index: 2;
  .iconfont {
    line-height: 28px;
    display: block;
    // font-size: 12px;
  }
  .icon-collection {
    color: #e54b4b;
    // line-height: 28px;
  }
  &:hover {
    background: #eeedf1;

    .iconfont {
      color: #fff;
    }

    .icon-collection {
      color: #e54b4b;
      // line-height: 28px;
    }

    .icon-uncollection {
      color: #333333;
      // line-height: 28px;
    }
  }
}
.messageBoxClass {
  .el-message-box__header {
    padding: 16px 16px 14px;
  }
  .el-message-box__content {
    padding: 10px 15px 24px 15px;
  }
  .el-message-box__status + .el-message-box__message {
    padding-left: 26px;
  }
  .el-message-box__status {
    font-size: 18px !important;
  }
  .el-message-box__btns {
  }
  //  .el-button--primary {
  //   &.confirmbutton {
  //     background-color: #7966ff !important;
  //     border-color: #7966ff !important;
  //     &:hover {
  //       background: #9485ff !important;
  //       border-color: #9485ff !important;
  //     }
  //   }
  // }
  .el-button {
    &.cancelbutton {
      &:hover {
        background: #fbfaff !important;
        color: #7966ff !important;
        border-color: #e8e5ff !important;
      }
    }
  }
}
.el-backtop {
  img {
    width: 44px;
  }
}

.loading-icon {
  margin-top: 40px;
  margin-bottom: 40px;

  span.el-icon-loading {
    font-size: 24px;
    color: #999999;
  }
  @include flex();
  @include justify-content(center);
  @include align-item(center);
  .images-request-tip {
    padding-left: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1920px) {
  .mydeisgn-datalist ul li {
    width: calc((100% - 150px) / 6);
  }
  .mydeisgn-datalist ul li:nth-of-type(6n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 1921px) {
  .mydeisgn-datalist ul li {
    width: calc((100% - 150px) / 6);
  }

  .mydeisgn-datalist ul li:nth-of-type(6n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 1366px) and (max-width: 1599px) {
  .mydeisgn-datalist ul li {
    width: calc((100% - 120px) / 5);
  }
  .mydeisgn-datalist ul li:nth-of-type(5n) {
    margin-right: 0;
  }
}
.apply-status-tip {
  width: 54px;
  height: 54px;
  margin: 74px auto 18px;
}

.apply-status-tip img {
  width: 100%;
}

.padding-none {
  padding: 0px 0px;
}

.tips-msg {
  width: 287px;
  height: 43px;
  margin: 0 auto 40px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
}

.buy-vip-btn {
  display: block;
  width: 200px;
  height: 32px;
  background: rgba(121, 102, 255, 1);
  border-radius: 4px;
  margin: auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 32px;
  text-align: center;
}

.member-none {
  height: calc(100vh - 220px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
  img {
    margin: 0;
    margin-bottom: 40px;
  }

  img,
  p {
    transform: none !important;
  }
}
</style>
